import { combineReducers } from "@reduxjs/toolkit";
import commentsSlice from "./commentsReducer";

export default combineReducers({
    commentsSlice
})